import { Injectable } from '@angular/core';
import { Notyf } from 'notyf';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private notyf: Notyf;
  private currentNotification: any; // guarda a notificação atual

  constructor() {
    this.notyf = new Notyf({
      duration: 3000,
      position: { x: 'right', y: 'top' }
    });
  }

  success(message: string) {
    this.dismissCurrent(); // remove a anterior
    this.currentNotification = this.notyf.success(message);
  }

  error(message: string) {
    this.dismissCurrent();
    this.currentNotification = this.notyf.error(message);
  }

  info(message: string) {
    this.dismissCurrent();
    this.currentNotification = this.notyf.open({
      type: 'info',
      message
    });
  }

  // warning(message: string) {
  //   this.dismissCurrent();
  //   this.currentNotification = this.notyf.open({
  //     type: 'warning',
  //     message
  //   });
  // }

  private dismissCurrent() {
    if (this.currentNotification) {
      this.notyf.dismiss(this.currentNotification);
      this.currentNotification = null;
    }
  }
}
